<template>
  <div>
    <v-row justify="space-between" class="header-container">
      <v-col md="6" :cols="12" class="pa-0">
        <div class="url-header">URL Link</div></v-col
      >
      <v-col md="6" :cols="12" class="pa-0">
        <div class="tab-header-text text-right">
          <v-btn
            @click="editUrl(null)"
            elevation="0"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
          >
            <v-icon left>mdi-plus</v-icon>
            Add URL Link
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-if="listUrl == null || listUrl.length == 0">
      <v-row class="ma-0" align="center" justify="center">
        <v-icon class="mx-auto" color="#E1E2E6" size="200px">mdi-link</v-icon>
      </v-row>
      <v-row class="ma-0" align="center" justify="center">
        <div class="font-weight-bold no-data">ไม่มีลิงก์ให้แสดง</div>
      </v-row>
    </div>
    <div v-if="listUrl !== null && listUrl.length > 0">
      <!-- <div v-for="urlDetail in urls" :key="urlDetail._id" class="url-container">
        <v-row class="ma-0">
          <v-col :cols="1" class="pa-0">
            <v-icon>mdi-link-variant</v-icon>
          </v-col>
          <v-col :cols="10" class="pa-0">
            <v-row class="ma-0">
              <span class="url-name">{{urlDetail.title}}</span>
            </v-row>
            <v-row class="ma-0">
              <a @click="openNewWeb(urlDetail.url)" class="url-link" >{{ urlDetail.url }}</a>
            </v-row>
          </v-col>
          <v-col :cols="1" class="pa-0 url-action">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-col>
        </v-row>
      </div> -->
      <div v-for="url in listUrl" :key="url._id" class="url-container">
        <div class="url-icon"><v-icon>mdi-link-variant</v-icon></div>
        <div class="url-action">
          <!-- <v-icon>mdi-dots-horizontal</v-icon> -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </div>
            </template>
            <v-list>
              <v-list-item @click="editUrl(url)">
                <v-list-item-icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="deleteDialog(url._id)">
                <v-list-item-icon>
                  <v-icon>mdi-trash-can</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="url-detail">
          <v-row class="ma-0">
            <span class="url-name">{{ url.title }}</span>
          </v-row>
          <v-row class="ma-0">
            <a @click="openNewWeb(url.url)" class="url-link">{{ url.url }}</a>
          </v-row>
        </div>
        <!-- <v-row class="ma-0">
          <v-col :cols="1" class="pa-0">
            <v-icon>mdi-link-variant</v-icon>
          </v-col>
          <v-col :cols="10" class="pa-0">
            <v-row class="ma-0">
              <span class="url-name">{{urlDetail.title}}</span>
            </v-row>
            <v-row class="ma-0">
              <a @click="openNewWeb(urlDetail.url)" class="url-link" >{{ urlDetail.url }}</a>
            </v-row>
          </v-col>
          <v-col :cols="1" class="pa-0 url-action">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-col>
        </v-row> -->
      </div>

      <v-pagination
        v-model="currentPage"
        class="pagination-align-right justify-flex-end"
        :length="totalUrl"
      ></v-pagination>
    </div>
    <InsertUrlDialog
      :isDialogOpen.sync="openEditDialog"
      :closeDialog.sync="closeDialog"
      :getListUrl.sync="getListUrl"
      :liveId.sync="liveId"
      :urlDetail.sync="urlDetail"
      :total.sync="urls.length"
    />
    <v-dialog v-model="deleteDialogStatus" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertDeleteLesson'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.live.alertDeleteUrlCantBringData'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2 font-weight-light"
            dark
            outlined
            @click="closeDeleteDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2 font-weight-light"
            color="error darken-1"
            dark
            @click="deleteUrlById"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import InsertUrlDialog from '@/components/live/dialog/insertUrlDialog';
import { getListUrl, deleteUrl } from '@/service/course/livev2.js';
export default {
  props: {
    liveId: {
      type: String,
    },
  },
  data: () => ({
    urls: [],
    openEditDialog: false,
    urlDetail: null,
    deleteDialogStatus: false,
    deleteId: null,
    sizePerPage: 5,
    currentPage: 1,
  }),
  computed: {
    listUrl() {
      const start = (this.currentPage - 1) * this.sizePerPage,
        end = start + this.sizePerPage;
      let data = this.urls;
      return data.slice(start, end);
    },
    totalUrl() {
      let l = this.urls.length,
        s = this.sizePerPage;
      return Math.ceil(l / s);
    },
  },
  components: {
    InsertUrlDialog,
  },
  async mounted() {
    await this.getListUrl();
  },
  methods: {
    async getListUrl() {
      let result = await getListUrl(this.liveId);
      this.urls = result;
    },
    async editUrl(detail) {
      this.openEditDialog = true;
      this.urlDetail = detail;
    },
    async closeDialog() {
      this.openEditDialog = false;
      await this.getListUrl();
    },
    async deleteDialog(id) {
      this.deleteDialogStatus = true;
      this.deleteId = id;
    },
    async deleteUrlById() {
      let result = await deleteUrl(this.liveId, this.deleteId);
      await this.closeDeleteDialog();
    },
    async closeDeleteDialog() {
      this.deleteDialogStatus = false;
      await this.getListUrl();
    },
    openNewWeb(url) {
      window.open(
        url,
        'vuetifyjs',
        'resizable,scrollbars,status,width=1000,height=700'
      );
    },
  },
};
</script>
<style scoped>
.is-ltr .v-list-item__icon:first-child {
    margin-right: 16px;
}

.description {
  font-size: 16px;
}
.no-data {
  color: #e1e2e6;
}
.chat-avatar {
  padding: 10px 10px 10px 0px;
  display: inline-table;
}
.chat-message {
  padding: 10px;
  display: inline-table;
  font-size: 16px;
  /* width: 50px; */
}
.box-disable {
  background-color: #f4f4f4;
  vertical-align: center;
  width: 100%;
  height: 100%;
  margin: auto;
  /* width: 60%; */
  /* border: 3px solid #73AD21; */
  padding: 6px;
}
.white-text-btn {
  color: white;
}
.url-header {
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.url-name {
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-bottom: 9px;
}
.url-link {
  font-size: 14px;
  font-weight: normal;
  /* font-stretch: normal; */
  /* font-style: normal; */
  line-height: normal;
  letter-spacing: normal;
  /* color: #4a90e2; */
}
.url-container {
  border-radius: 4px;
  background-color: #f7f7f7;
  padding: 20px;
  margin-bottom: 10px;
  width: 100%;
}
.header-container {
  margin: 0px;
  margin-bottom: 30px;
}
.url-icon {
  float: left;
  width: 37px;
  margin-top: 8px;
}
.url-action {
  float: right;
  width: 37px;
  align-self: center;
  margin-top: 8px;
}
.url-detail {
  margin: 0 auto;
  width: calc(100% - 37px - 37px);
  line-break: anywhere;
}
.pagination-align-right {
  justify-content: flex-end;
  padding-top: 15px;
}
</style>

<style lang="scss">
.pagination-align-right {
  .v-pagination__item--active {
    background-color: #308ab7 !important;
    border-color: #308ab7 !important;
  }
}
.pagination-align-right.justify-flex-end {
  .v-pagination.theme--light {
    justify-content: flex-end;
  }
}
.live-list{
  .v-list-item__icon:first-child{
  margin-right: 16px!important;
  }
}
</style>